module.exports = __webpack_public_path__ + "5188a8d913480a49a043db4d3551b846.png";